import {setConfig} from './ajax'

// 解析Json
const parseJson = str => {
  let resp = null
  try {
    resp = JSON.parse(str)
  } catch (e) {
  }
  return resp || {}
}

setConfig({
  // options: {
  //   withCredentials: true
  // },
  cache: false,
  headers: {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
    'template' : ''
  },
  responseHandle(xhr) {
    return new Promise((resolve, reject) => {
      const respText = xhr.responseText
      if (xhr.status === 401) {
        // 如果没有cookie则跳转单点登录界面
        const location = xhr.getResponseHeader('Location')
        if (location) {
          const rurl = `${location.split('?')[0]}?ReturnUrl=${window.location.origin}`
          window.location.href = rurl
        }
      }

      const resp = parseJson(respText)
      resolve(resp)
    })
  }
})
